import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  REPORT,
  REPORT_CATEGORY_NAMES,
  getBand,
} from "@/lib/relationshipReport";

const CATEGORY_ORDER = [
  "foundation",
  "quick_connect",
  "sensory_sync",
  "grand_vision",
];

const URL_RE = /^https?:\/\/\S+$/i;

function ReportParagraph({ text }) {
  if (URL_RE.test(text.trim())) {
    return (
      <a
        href={text.trim()}
        target="_blank"
        rel="noopener noreferrer"
        className="underline text-connexus font-semibold break-all"
      >
        {text.trim()}
      </a>
    );
  }
  return <p>{text}</p>;
}

export default function PersonalizedReport({ scores, primary }) {
  return (
    <section
      className="mt-10 fade-up"
      data-testid="personalized-report-section"
    >
      <h2 className="font-heading text-2xl sm:text-3xl tracking-tight text-connexus font-bold mb-2 text-left">
        Your Personalized Relationship Report
      </h2>
      <p className="text-sm sm:text-base text-connexus-textSecondary leading-relaxed mb-6 text-left max-w-2xl">
        While one area emerged as your biggest opportunity, every area of your
        relationship tells part of the story. Explore your personalized
        breakdown below.
      </p>

      <Accordion
        type="single"
        collapsible
        defaultValue={primary}
        className="flex flex-col gap-3"
      >
        {CATEGORY_ORDER.map((cat) => {
          const score = Number(scores[cat] ?? 0);
          const band = getBand(score);
          const content = REPORT[cat][band];

          return (
            <AccordionItem
              key={cat}
              value={cat}
              className="border border-connexus-border rounded-2xl bg-white shadow-connexus-card overflow-hidden"
              data-testid={`report-item-${cat}`}
            >
              <AccordionTrigger className="px-5 py-4 hover:no-underline">
                <div className="flex-1 flex flex-wrap items-center gap-x-3 gap-y-1 pr-3 text-left">
                  <span className="font-heading text-lg sm:text-xl text-connexus font-bold">
                    {REPORT_CATEGORY_NAMES[cat]}
                  </span>
                  <span className="text-sm sm:text-base font-semibold text-connexus-textSecondary">
                    {score.toFixed(1)}/10
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-5 pb-5 pt-0">
                <h3 className="font-heading text-lg sm:text-xl text-connexus font-bold mb-3">
                  {content.title}
                </h3>
                <div className="flex flex-col gap-3 text-[15px] leading-[1.7] text-connexus-textSecondary text-left">
                  {content.paragraphs.map((p, i) => (
                    <ReportParagraph key={i} text={p} />
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </section>
  );
}
